$(function () {
  
  // Scroll du résultat de recherche    
  $('.wrap--candidates-search').mCustomScrollbar({
    theme:"dark-thin",
    mouseWheel:{ deltaFactor: 1000},
    callbacks:{
      onTotalScroll:function(){
        const url =  $('.js-franchisor-search').data('url') 
        const $form = $('#form-search-candidates'); 
        //const query = '?q=' + $('.js-search-contacts').val()
        if (url) {
          setCffLoader('show', '.wrap-search-candidate-loader') 
          $form.attr('action', url)
          //$(this).find('.cff__loading').show()
          axios.post(url, $form.serialize())
          .then((response) => { 
            setCffLoader('hide', '.wrap-search-candidate-loader') 
            //$(this).find('.cff__loading').hide()
            // Changer les images dans le site
            if (response.data.html) { 
              $('.js-franchisor-search').data('url', response.data.url)
              $(this).find('.mCSB_container').append(response.data.html)
            }
          })
        }
      }}
    })
    // Faire un trigger submit lors d'une modif
    $('#form-search-candidates select, input#countries, input[type=range], input.created_at_begin').change(function(e) {
      loadCandidates()
      e.preventDefault()
    })
    
    // Lancer la recherche
    $('.subimt-search button').on('click', function(e) {
      loadCandidates()
      e.preventDefault()
    });
    
    // au clique sur Voir Plus  
    $('.candidates-search-btn-view-more').on('click', function(e) {
      e.preventDefault()
      const url =  $('.js-franchisor-search').data('url') 
      const $form = $('#form-search-candidates');
      if (url) {
        setCffLoader('show', '.wrap-search-candidate-loader') 
        $form.attr('action', url)
        axios.post(url, $form.serialize())
        .then((response) => { 
          // Changer les images dans le site
          setCffLoader('hide', '.wrap-search-candidate-loader') 
          $('.js-franchisor-search').data('url', response.data.url)
          $('.candidates--search--js').append(response.data.html)
          if (response.data.url === null) {
            $('.candidates-search-btn-view-more').addClass('hidden')
          }
          
        })
      }
    })

    dateSearchflatpickr = $('.js-cff--flatpickr').flatpickr({
      time_24hr: true,
      altInput: true,	
      altFormat: "j F Y",
      dateFormat:  "Y-m-d",
      locale: "fr",
      onClose: function(selectedDates, dateStr, instance){
        loadCandidates()
      }
  
    });

    // Reset selection
    $('.js-reset-selection').on('click', function(e) {
      var $this = $(this)
      var type = $this.data('type')
      var $filterElement = $('.filters-' + type)

      if (type === 'top') {
        // reset toute la france
        var $countries = $('#countries')
        $countries.prop('checked', false).val(0)
        $filterElement.find('.location-zones').removeClass('hidden')
        // reset Autre pays
        var $has_other_localize = $('#has_other_localize')
        $has_other_localize.prop('checked', false).val(0)
        $filterElement.find('#other-countries').addClass('hidden')
      
      } else {

        const ranges = document.querySelectorAll('.input-range')
        
          ranges.forEach((range) => {
            const input = range.querySelector('input[type="range"]')
            range.setAttribute('data-value', 0)
            input.value = 0        
          })
    
        // Reset des dates
        dateSearchflatpickr.forEach(function(dateSearch,key) {
          dateSearch.clear()
        })
      }
      
      $filterElement.find('select').val('').trigger('change')
      
      e.preventDefault()
    })

    // Afficher/cacher le loader
    function setCffLoader(action = 'show', element = 'body') {
      
      if (action === 'show') {
        $(element).addClass('cff--loading--wrap')  
      } else {
        $(element).removeClass('cff--loading--wrap')  
      }
      
    }
    // Charger les candidats
    function loadCandidates() {
      const $form = $('#form-search-candidates')
      const url = $form.data('url')
      $form.attr('action', url)
      if (url) {
        setCffLoader('show', '.wrap-search-candidate-loader') 
        axios.post(url, $form.serialize())
        .then((response) => {  
          setCffLoader('hide', '.wrap-search-candidate-loader') 
          // Changer les images dans le site
          const total = response.data.total
          const textTotal = response.data.total > 1 ? total + ' résultats' : total + ' résultat'
          $('.total-search').html(textTotal)
          $('.js-franchisor-search').data('url', response.data.url)
          const hasScroll = $('.mCSB_container:visible')
          if (hasScroll.length === 1) {
            classWrapCandidates = '.mCSB_container'
          } else {
            classWrapCandidates = '.candidates--search--js'
            if (response.data.url !== null) {
              $('.candidates-search-btn-view-more').removeClass('hidden')
            } else {
              $('.candidates-search-btn-view-more').addClass('hidden')
            }
          }
          $(classWrapCandidates).html(response.data.html)
        })
      }
      
    }
  })


// WEBPACK FOOTER //
// ./resources/assets/js/components/search-candidates.js